import { MediaQuery } from '@cae/cobalt-react/enums';
import { useMediaQuery } from '@cae/cobalt-react/hooks';
import { useHasPermission } from '@contexts/permissions-provider';
import * as React from 'react';
import { Navigate } from 'react-router-dom';

import { ProfilePage } from '../../ProfilePage';

const ProfileEntryRoute = React.memo((): React.ReactElement => {
  const isTabletAndDesktop = useMediaQuery(MediaQuery.TabletAndDesktop);
  const canViewProfileTraining = useHasPermission('ProfilePersonalTraining_FullAccess_Own');
  const canViewProfileBasic = useHasPermission('ProfilePersonalBasic_FullAccess_Own');
  const canViewNotifications = useHasPermission('ProfileNotifications_FullAccess_Own');
  const canViewPassword = useHasPermission('ProfilePassword_FullAccess_Own');
  const canViewPersonalInfo = canViewProfileTraining || canViewProfileBasic;
  const isPasswordOnly = canViewPassword && !canViewPersonalInfo && !canViewNotifications;

  if (isPasswordOnly) {
    return <Navigate to="password-and-security" replace />;
  }

  if (isTabletAndDesktop) {
    if (canViewPersonalInfo) {
      return <Navigate to="personal-information" replace />;
    }

    if (canViewNotifications) {
      return <Navigate to="notifications" replace />;
    }

    return <Navigate to="password-and-security" replace />;
  }

  return <ProfilePage />;
});

ProfileEntryRoute.displayName = 'ProfileEntryRoute';

export { ProfileEntryRoute };
